import type { Directive, Handle } from "micromark-extension-directive";
import { directive, directiveHtml } from "micromark-extension-directive";

const SAFE_URL_PATTERN = /^(https?:\/\/|mailto:)/i;
const isSafeUrl = (url: string): boolean => {
  if (!url) return false;

  // Strip C0/C1 control characters, delete, and whitespace that browsers
  // silently remove during URL parsing (per WHATWG URL spec)
  // eslint-disable-next-line no-control-regex
  const normalized = url.replace(/[\u0000-\u0020\u007f]/g, "");

  return SAFE_URL_PATTERN.test(normalized);
};

const handleLinkDirective: Handle = function (this, d: Directive) {
  if (d.type !== "textDirective") return false;

  const href = d.attributes?.href;
  const target = d.attributes?.target;
  const label = d.label ?? "";

  if (!href || !isSafeUrl(href)) {
    this.raw(label);
    return true;
  }

  const encodedHref = this.encode(href);

  if (target === "_blank") {
    this.tag(
      `<a href="${encodedHref}" target="_blank" rel="noopener noreferrer">`,
    );
  } else {
    this.tag(`<a href="${encodedHref}">`);
  }

  this.raw(label);
  this.tag("</a>");

  return true;
};

export const linkDirectiveSyntaxExtension = directive();
export const linkDirectiveHtmlExtension = directiveHtml({
  a: handleLinkDirective,
});
